import { useMemo } from "react";
import { getDisplayedEntityIds } from "@common/types/domains/accounting/chartOfAccountsViewFilters";
import { AccountingReportFilters } from "../types";

function hasEntitySubset({
    entityIds,
    allEntityIds,
}: {
    entityIds?: number[];
    allEntityIds: number[];
}): boolean {
    if (!entityIds?.length || entityIds.length >= allEntityIds.length) {
        return false;
    }

    const selectedEntityIds = new Set(entityIds);
    return allEntityIds.some((entityId) => !selectedEntityIds.has(entityId));
}

export function useCoaFiltersActive({
    filters,
    allEntityIds,
}: {
    filters: AccountingReportFilters;
    allEntityIds: number[];
}): boolean {
    return useMemo(
        () =>
            hasEntitySubset({
                entityIds: getDisplayedEntityIds({
                    entityId: filters.entityId,
                    entityIds: filters.entityIds,
                }),
                allEntityIds,
            }) ||
            !!filters.accountStatus ||
            !!filters.accountSource ||
            !!filters.accountRolePresence ||
            !!filters.accountRulePresence ||
            (filters.accountSubtypes?.length ?? 0) > 0 ||
            (filters.form1099Boxes?.length ?? 0) > 0 ||
            !!filters.search ||
            (filters.coaTemplateGroupKeys?.length ?? 0) > 0,
        [
            filters.entityId,
            filters.entityIds,
            filters.accountStatus,
            filters.accountSource,
            filters.accountRolePresence,
            filters.accountRulePresence,
            filters.accountSubtypes,
            filters.form1099Boxes,
            filters.search,
            filters.coaTemplateGroupKeys,
            allEntityIds,
        ],
    );
}
